import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

import {TelegramChat} from "@/lib/queries/integrations.ts";

export const TelegramShape = {
  telegram_username: Yup.string()
    .label("Telegram Username")
    .transform((curr, orig) => (orig === "" ? undefined : curr))
    .min(5)
    .max(32),
  chat_id: Yup.string().label("Group ID").required(),
  chat_title: Yup.string().label("Group Title").max(512).optional(),
};

export interface TelegramInput {
  telegram_username?: string;
  chat_id: string;
  chat_title?: string;
}

yupResolver<TelegramInput>(Yup.object().shape(TelegramShape));

export type TelegramChatList = {
  telegramUsername: string;
  chats: TelegramChat[] | null;
};
